// app/javascript/src/drawer.js
export function initDrawer({
  overlayId = "drawer-overlay",
  triggerSelector = ".js-drawer-trigger",
  closeSelector = '[data-close="drawer"]',
  openClass = "is-open",
  bodyOpenClass = "drawer-open",
} = {}) {
  const overlay = document.getElementById(overlayId);
  if (!overlay) return;

  let lastTrigger = null;

  const isOpen = () => overlay.classList.contains(openClass);

  const open = (trigger) => {
    lastTrigger = trigger ?? lastTrigger;
    requestAnimationFrame(() => overlay.classList.add(openClass));
    lastTrigger?.setAttribute("aria-expanded", "true");
    document.body.classList.add(bodyOpenClass);
  };

  const close = () => {
    overlay.classList.remove(openClass);
    document.body.classList.remove(bodyOpenClass);
    lastTrigger?.setAttribute("aria-expanded", "false");
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(triggerSelector);
    if (trigger) {
      e.preventDefault();
      isOpen() ? close() : open(trigger);
      return;
    }

    if (e.target.matches(closeSelector)) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) close();
  });
}
